"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getFlattenedFields = exports.getSectionFields = exports.submitOnlyChangedFields = exports.hasDuplicateFields = exports.cleanValidationErrors = exports.submitFormAsync = exports.validateForm = exports.updateFieldState = void 0;
var component_button_1 = __importDefault(require("@doordash/component-button"));
var lodash_1 = require("lodash");
/**
 * FormState update helper
 */
exports.updateFieldState = function (key, formState, setFormState) { return function (value) {
    var _a;
    setFormState(__assign(__assign({}, formState), (_a = {}, _a[key] = value, _a)));
}; };
/**
 * Process all required fields and set errors
 *
 * @param errors Currently detected errors
 * @param formConfig Form configuration (isRequired, etc)
 * @param formState Current form values
 * @param setErrors Fn to update errors in state
 */
exports.validateForm = function (errors, formConfig, formState, setErrors) {
    var updatedErrors = errors;
    Object.keys(formConfig).map(function (field) {
        var _a = formConfig[field], props = _a.props, name = _a.name;
        var value = formState[field];
        if (props.isRequired && !value && !errors[field]) {
            updatedErrors[field] = name + " is required";
        }
        setErrors(__assign({}, updatedErrors));
    });
};
/**
 * Validate and submit the form values
 *
 * @param errors Currently detected errors
 * @param setErrors Fn to update errors in state
 * @param setButtonState Fn to update button UI state
 * @param onSubmit Callback to submit the form
 * @param formConfig Form config (isRequired, etc)
 * @param formState Current form values
 */
exports.submitFormAsync = function (errors, setErrors, setButtonState, onSubmit, formConfig, formState, initialData) { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                exports.validateForm(errors, formConfig, formState, setErrors);
                if (!lodash_1.isEmpty(errors)) return [3 /*break*/, 2];
                setButtonState(component_button_1["default"].States.Loading);
                return [4 /*yield*/, onSubmit(formState, initialData)];
            case 1:
                _a.sent();
                setButtonState(component_button_1["default"].States.Success);
                _a.label = 2;
            case 2: return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                setErrors(e_1);
                setButtonState(component_button_1["default"].States.Error);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Clear errors for any field in state
 *
 * @param formState Current form values
 * @param errors Currently detected errors
 * @param setErrors Fn to update errors in state
 */
exports.cleanValidationErrors = function (formState, errors, setErrors) {
    var copyErrors = __assign({}, errors);
    Object.keys(formState).map(function (field) {
        if (formState[field] && copyErrors[field]) {
            delete copyErrors[field];
        }
    });
    setErrors(copyErrors);
};
exports.hasDuplicateFields = function (fields) {
    var findDuplicates = function (arr) {
        return arr.filter(function (item, index) { return arr.indexOf(item) !== index; });
    };
    var result = lodash_1.flattenDeep(fields).map(function (a) { return a.key; });
    return !!findDuplicates(result).length;
};
/**
 * Helper for generating submit functions that are aware of initial data.
 *
 * @param formState Current FormState
 * @param initialData Initial FormState
 * @param submit Function to call with updated values
 */
exports.submitOnlyChangedFields = function (submit) { return function (formState, initialData) {
    if (initialData === void 0) { initialData = {}; }
    var updatedData = {};
    Object.keys(formState).forEach(function (key) {
        if (formState[key] !== initialData[key]) {
            updatedData[key] = formState[key];
        }
    });
    // TODO: Do we want to handle empty updates in this function or in the
    // submit handlers?
    return submit(updatedData);
}; };
exports.getSectionFields = function (section) {
    if (section.rows) {
        return lodash_1.flatMap(section.rows);
    }
    return lodash_1.flatMap(section.sections, exports.getSectionFields);
};
exports.getFlattenedFields = function (fields, fieldsHasSections) {
    var mapFn = fieldsHasSections ? exports.getSectionFields : lodash_1.identity;
    return lodash_1.flatMap(fields, mapFn);
};
